/** Player upload / game starting route used by header Back navigation. */
export const GAME_UPLOAD_PATH = "/game";

/** Intro screen before upload. */
export const HOW_TO_PLAY_PATH = "/how-to-play";
